module.exports = flarum.core.compat['components/Switch'];